"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageApi = void 0;
const SetPixelsMessage_1 = require("./messages/SetPixelsMessage");
// import Jimp from 'jimp';
const jimp_1 = __importDefault(require("jimp/browser/lib/jimp")); // For browser support.
const ColorConverter_1 = require("./ColorConverter");
class ImageApi {
    constructor(config) {
        this._config = config;
    }
    set(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const values = [];
            const image = yield jimp_1.default.read(path);
            yield image.resize(this._config.displayConfig.width, this._config.displayConfig.height, jimp_1.default.RESIZE_BILINEAR);
            for (let y = 0; y < image.getHeight(); y++) {
                for (let x = 0; x < image.getWidth(); x++) {
                    const colour = image.getPixelColor(x, y);
                    const asRGBA = jimp_1.default.intToRGBA(colour);
                    const asHex = ColorConverter_1.ColorConverter.forceHex(asRGBA);
                    values.push({ x, y, color: asHex });
                }
            }
            const message = SetPixelsMessage_1.SetPixelsMessage.fromPixelValueCollection(values);
            this._config.deviceAdapter.sendPixels(message);
        });
    }
}
exports.ImageApi = ImageApi;
//# sourceMappingURL=ImageApi.js.map